module.exports = "<ul>\n    <% for(i in docs) { %>\n        <% if (docs.hasOwnProperty(i)) { doc = docs[i]; %>\n            <li><a target=\"_blank\" href=\"<%= doc.link %>\"><%= doc.name %></a></li>\n        <% } %>\n    <% } %>\n</ul>";
